// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Sz4So","validationTips":"StatementDescriptor_validationTips__2I2QP"};